
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { uploadImage, uploadFile } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class UploadImage extends Vue {
  @Prop({
    default: (): string[] => {
      return ["png", "jpg", "jpeg", "gif"];
    }
  })
  private fileType!: string[];
  @Prop({ default: "image" }) private uploadFileType!: string;
  @Prop({ default: 0 }) private index!: number;
  @Prop({ default: "" }) private objKey!: string;
  @Prop({ default: "" }) private btnName!: string;
  @Prop({ default: "primary" }) private btnType!: string;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private returnFile!: boolean;

  private fileInput: objAny = {};
  private loading = false;
  public fileChange(e: objAny): void {
    const file: File = e.target.files[0];
    if (file) {
      const name: string = file.name;
      if (this.fileType.length > 0) {
        const n: number = name.lastIndexOf(".");
        const houName: string = name.substring(n + 1).toLowerCase();
        let isYes = false;
        for (let i = 0; i < this.fileType.length; i++) {
          const yesName = this.fileType[i];
          if (yesName.toLowerCase() === houName) {
            isYes = true;
          }
        }
        if (!isYes) {
          this.$Message.error(
            i18n.t("formText.uploadError") + this.fileType.join(",")
          );
          this.fileInput.value = "";
          return;
        }
      }
      if (this.returnFile) {
        this.$emit("change", e.target.files[0]);
      } else {
        this.getImgs(e.target.files[0]);
      }
    }
  }
  public resetFile(): void {
    this.fileInput.value = "";
  }
  public upload(): void {
    if (!this.fileInput.$el) {
      this.fileInput = this.$refs.fileInput;
    }
    this.fileInput.click();
  }
  async getImgs(file: File): Promise<void> {
    const formData = new FormData(); // 创建表单
    formData.append('file', file); // eslint-disable-line
    const headers = { "Content-Type": "multipart/form-data" };
    let ret: objAny;
    this.loading = true;
    if (this.uploadFileType === "image") {
      ret = await uploadImage(formData, headers);
    } else {
      ret = await uploadFile(formData, headers);
    }
    this.loading = false;
    this.fileInput.value = "";
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      data.key = this.objKey;
      data.index = this.index;
      this.$emit("change", data);
    }
  }
  // mounted() {}
}
